export const toFixedNumber = value => {
    return Number.parseFloat(value || 0).toFixed(2) || '';
};

export const calculateTotal = (list, key) => (
    list?.reduce((acc, item) => acc + (item?.[key] || 0), 0)
);
